import axiosInstance from "./axiosInstance";

export const getNochesUsuarios = async (page=1, search=null, limit=10) => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/nochesUsuario?page=${page}&limit=${limit}${search ? `&search=${search}` : ""}`,
        { withCredentials: true }
    );
}

export const putNochesUsuario = async (data) => {
    return await axiosInstance.put(
        `${process.env.REACT_APP_BASE_URL}/nochesUsuario`,
        data,
        { withCredentials: true }
    );
}

export const putNochesUsuarioAll = async (data) => {
    return await axiosInstance.put(
        `${process.env.REACT_APP_BASE_URL}/nochesUsuario/all`,
        data,
        { withCredentials: true }
    );
}


export const getNochesLiberadas = async (year, page, search=null, all=null) => {
    const params = {
        year,
        page
    }
    if (search) {
        params.search = search;
    }
    if (all) {
        params.all = all;
    }

    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/nochesLiberadas`,
        {
            params,
            withCredentials: true 
        }
    );
}

export const liberarNoches = async (idUser) => {
    return await axiosInstance.put(
        `${process.env.REACT_APP_BASE_URL}/nochesLiberadas/liberar`,
        { idUser },
        {
            withCredentials: true 
        }
    );
}

export const liberarNochesAll = async () => {
    return await axiosInstance.put(
        `${process.env.REACT_APP_BASE_URL}/nochesLiberadas/liberarTodos`,
        {},
        { withCredentials: true }
    );
}

// Llama al nuevo endpoint del backend para descargar el archivo CSV.
export const downloadNochesLiberadasCSV = async (year, search) => {
    const params = { year };
    if (search) {
        params.search = search;
    }
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/nochesLiberadas/download-csv`,
        {
            params,
            withCredentials: true,
            responseType: 'blob', // Importante para manejar la respuesta como un archivo
        }
    );
};
